import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import {
  addNewWindow,
  minimizeWindow,
  undoMinimizeWindow,
  maximizeWindow,
  undoMaximizeWindow,
  closeWindow,
  updateWindowGeometry,
  updateWindowPosition,
  switchWindow,
  switchActiveSheet,
} from './windowsSlice';
import { findWindow } from '../utils';
import { RootState } from '../../core/redux/store';
import userStorageWorker from '../../core/database/user/userWorkerManager';
import sessionStorageSingleton from '../../core/configs/sessionStorageSingleton';
import _ from 'lodash';
import { UserKeyStore, UserStorageDataType } from '../../core/database/schemas';
import { UserStorageParams } from '../../core/database/user/types';

const windowListenerMiddleware = createListenerMiddleware();

windowListenerMiddleware.startListening({
  matcher: isAnyOf(
    addNewWindow,
    updateWindowPosition,
    switchWindow,
    switchActiveSheet,
    minimizeWindow,
    undoMinimizeWindow,
    maximizeWindow,
    undoMaximizeWindow,
    closeWindow,
    updateWindowGeometry
  ),
  effect: async (action, listenerApi) => {
    const state = listenerApi.getState() as RootState;
    const userId = state.auth.user.id;
    const feKey = await sessionStorageSingleton.getFeKey(
      UserKeyStore.UserFeKey
    );

    if (state.auth.user.id && state.auth.app.isMasterTab && feKey) {
      const windowId =
        _.isEqual(action.type, updateWindowPosition.toString()) ||
        _.isEqual(action.type, updateWindowGeometry.toString()) ||
        _.isEqual(action.type, switchActiveSheet.toString())
          ? action.payload.id
          : action.payload;

      const window =
        action.type === addNewWindow.toString()
          ? action.payload
          : findWindow(state.windows.windowList, windowId);

      const params: UserStorageParams = {
        actionType: action.type,
        userId: state.auth.user.id,
        feKey,
        data: {
          dataType: UserStorageDataType.Windows,
          windowId: windowId,
          window,
        },
      };

      userStorageWorker.postMessage(params);
    }
  },
});

export default windowListenerMiddleware.middleware;
